import React from 'react';
import { useTheme } from './ThemeProvider';
import './theme-toggle.css';

const MODE_META = {
  system: { icon: 'fa-circle-half-stroke', label: 'System theme', next: 'light' },
  light: { icon: 'fa-sun', label: 'Light theme', next: 'dark' },
  dark: { icon: 'fa-moon', label: 'Dark theme', next: 'system' },
};

/**
 * One button that cycles system -> light -> dark. The current mode is exposed
 * to assistive technology through the label rather than a visible caption, so
 * the control stays a single 44px target.
 */
export default function ThemeToggle({ className = '', onClick }) {
  const { mode, cycleMode } = useTheme();
  const meta = MODE_META[mode] || MODE_META.system;

  const handleClick = (event) => {
    cycleMode();
    if (onClick) onClick(event);
  };

  return (
    <button
      type="button"
      className={`kds-icon-btn kds-theme-toggle ${className}`.trim()}
      onClick={handleClick}
      aria-label={`${meta.label}. Switch to ${MODE_META[meta.next].label.toLowerCase()}.`}
      title={meta.label}
    >
      <i className={`fas ${meta.icon}`} aria-hidden="true"></i>
    </button>
  );
}
